// Shared types for the 3-column course editor workspace.

// The course-level fields edited in the Basics tab and saved together with the gallery
// via the page header's Save button.
export interface CourseBasics {
  title: string;
  slug: string;
  description: string;
  duration: string;
  price: number;
  currency: string;
  category: string;
  startDate: string;
  startDateTimezone: string;
  accessDurationDays: number;
  accessExpiresAt: string;
  stripeEnabled: boolean;
  paymentProvider: 'custom' | 'platform';
  learningOutcomes: string[];
}

// "What You'll Learn" bullet caps — keep in sync with the backend (courseService.ts).
export const MAX_LEARNING_OUTCOMES = 8;
export const MAX_LEARNING_OUTCOME_LENGTH = 200;

// What the outline (left column) currently has selected, routing the middle editor.
export type OutlineSelection =
  | { kind: 'basics' }
  | { kind: 'media' }
  | { kind: 'lesson'; id: string };

export interface PaymentCapabilities {
  customPaymentEnabled: boolean;
  hasStripeConfig: boolean;
  canConfigureStripe: boolean;
}
